import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgRecord = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.5 12a8.5 8.5 0 1 0 17 0 8.5 8.5 0 0 0-17 0m1.429 7.071A10 10 0 1 1 19.07 4.93 10 10 0 0 1 4.93 19.07"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgRecord;
